export const EmptyState = () => (
  <div className="flex min-h-[300px] flex-col items-center justify-center px-4 py-12">
    <img
      src="/suggested-providers.png"
      alt="No providers to show"
      className="mb-4 max-w-[200px]"
    />
    <h3 className="text-lg font-semibold">No providers to show</h3>
    <p className="text-muted-foreground text-sm">
      Providers found in patient medical records and sources will appear here.
    </p>
  </div>
);
